import { useEffect, useState } from "react";
import Container from "@/components/Container";
import Pager, { usePager } from "@/components/Pager";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function TasksAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", priority: "medium", due_date: "" });
  const load = () => api.get("/tasks").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!form.title) return toast.error("Title required");
    await api.post("/tasks", form);
    setForm({ title: "", priority: "medium", due_date: "" }); load();
  };
  const update = async (id, patch) => { await api.put(`/tasks/${id}`, patch); load(); };
  const del = async (id) => { await api.delete(`/tasks/${id}`); load(); };

  const pager = usePager(items);

  return (
    <Container className="py-8 md:py-12">
      <p className="overline">CRM</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Tasks</h1>

      <form onSubmit={create} className="luxury-card p-5 mt-6 grid grid-cols-1 md:grid-cols-5 gap-3">
        <input className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Task title" value={form.title} onChange={e => setForm({...form, title: e.target.value})} />
        <input type="date" className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" value={form.due_date} onChange={e => setForm({...form, due_date: e.target.value})} />
        <select className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" value={form.priority} onChange={e => setForm({...form, priority: e.target.value})}>
          {["low","medium","high","urgent"].map(p => <option key={p}>{p}</option>)}
        </select>
        <button className="btn-ruby justify-center">Add Task</button>
      </form>

      <div className="mt-6 luxury-card divide-y divide-charcoal-600/60">
        {items.length === 0 && <p className="p-8 text-center text-ivory/40 text-sm">No tasks.</p>}
        {pager.pageItems.map(t => (
          <div key={t.id} className="p-4 flex items-center justify-between gap-3" data-testid={`task-${t.id}`}>
            <div className="flex items-center gap-3 flex-1">
              <input type="checkbox" checked={t.status === "done"} onChange={e => update(t.id, { status: e.target.checked ? "done" : "open" })} className="accent-ruby" />
              <div className="flex-1">
                <p className={`text-ivory ${t.status === "done" ? "line-through text-ivory/40" : ""}`}>{t.title}</p>
                <p className="text-[0.65rem] text-ivory/50 uppercase tracking-[0.15em] mt-1">{t.priority} {t.due_date ? `· due ${t.due_date}` : ""}</p>
              </div>
            </div>
            <button onClick={() => del(t.id)} className="btn-outline !py-1 !px-2 !text-[0.65rem]">Delete</button>
          </div>
        ))}
      </div>
      <Pager {...pager} testid="tasks-pager" />
    </Container>
  );
}
